import { Button, Grid } from "@material-ui/core";
import { Check } from '@material-ui/icons';
import { Alert, AlertTitle } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import ReportApi from "../../services/ReportApi";

type Props = any;

const Success: React.FC<Props> = ({ opcoes, MvmNumber, MvmId, recordType }) => {
  const history = useHistory();
  const { t: tGeneral } = useTranslation("General")
  
  const openUrl = (url: string, state: any, mvmId: any) => {
    if (window.location.pathname == url)
    {  
      history.push({pathname: url, state: state});
      window.location.reload();
    }
    else if (url == 'printMvm')
    {
      ReportApi.printMvm(mvmId);
    }
    else
      history.replace(url);
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', paddingTop: 20}}>
        <Check color="primary" fontSize="large" style={{color: 'green', fontSize: 40}}/>
        <span style={{fontSize: 26, fontWeight: 'bold', marginLeft: 10}}>
          {tGeneral("successOperationMessage")}
        </span>
      </Grid>
      {MvmNumber && (
        <Grid item xs={12} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Grid item xs={5}>
            <Alert severity="info" style={{fontSize: 22}}>
              <AlertTitle>{tGeneral("information")}</AlertTitle>
              {tGeneral(`submitted${recordType ?? "Mvm"}Number`)}<strong>{MvmNumber}</strong>
            </Alert>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} style={{textAlign: 'center', padding: 3, }}>    
          <p style={{fontSize: 22, fontWeight: 'bold'}}>Opções:</p>
      </Grid>
      <Grid item xs={12} style={{textAlign: 'center'}}> 
        {opcoes?.map((opcao:any) => (
          <Button
            onClick={() => openUrl(opcao?.url, opcao?.state, MvmId)}
            variant="contained"
            color="primary" style={{width: 200, margin: 5}}>
              {opcao?.descricao}
          </Button>
        ))}
      </Grid>
    </Grid>
  )
}

export default Success;
